import { render, staticRenderFns } from "./fee.vue?vue&type=template&id=80c9a528&scoped=true"
import script from "./fee.vue?vue&type=script&lang=js"
export * from "./fee.vue?vue&type=script&lang=js"
import style0 from "./fee.vue?vue&type=style&index=0&id=80c9a528&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c9a528",
  null
  
)

export default component.exports